let option = {
  tooltip: {
    backgroundColor: '#404040',
    padding: [5, 8],
    textStyle: {
      fontSize: 12,
      lineHeight: 12
    },
    formatter: (item) => {
      return item.data.type == 3 ? item.data.name + '(点击查看详情)' : item.data.name
    }
  },
  series: [{
    type: 'sankey',
    left: 0,
    right: 0,
    data: [],
    links: [],
    nodeGap: 4,
    nodeWidth: 120,
    focusNodeAdjacency: true,
    draggable: false,
    levels: [{
      depth: 0,
      itemStyle: {
        borderWidth: 0,
        color: 'rgba(146, 84, 222, 1)'
      },
      lineStyle: {
        color: 'rgba(146, 84, 222, 1)',
        opacity: 0.3
      }
    }, {
      depth: 1,
      itemStyle: {
        borderWidth: 0,
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [{
            offset: 0,
            color: 'rgba(146, 84, 222, 1)'
          }, {
            offset: 1,
            color: 'rgba(47, 84, 235, 1)'
          }]
        }
      },
      lineStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [{
            offset: 0,
            color: 'rgba(146, 84, 222, 1)'
          }, {
            offset: 1,
            color: 'rgba(47, 84, 235, 1)'
          }]
        },
        opacity: 0.3
      }
    }, {
      depth: 2,
      itemStyle: {
        borderWidth: 0,
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [{
            offset: 0,
            color: 'rgba(64, 169, 255, 1)'
          }, {
            offset: 1,
            color: 'rgba(54, 207, 201, 1)'
          }]
        }
      },
      lineStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [{
            offset: 0,
            color: 'rgba(30, 166, 155, 1)'
          }, {
            offset: 1,
            color: 'rgba(255, 203, 106, 1)'
          }]
        },
        opacity: 0.3
      }
    }, {
      depth: 3,
      itemStyle: {
        borderWidth: 0,
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [{
            offset: 0,
            color: 'rgba(255, 203, 106, 1)'
          }, {
            offset: 1,
            color: 'rgba(233, 99, 80, 1)'
          }]
        }
      }
    }],
    label: {
      normal: {
        position: 'inside',
        formatter: (item) => {
          let txt = '', txt2 = '', num = item.data.type != 4 ? 7 : 6
          let len = Math.ceil(item.name.length / num)

          if (item.data.type == 3) {
            let val = item.data.value1 > 99 ? 'n+' : item.data.value1
            txt2 = '{a|' + val + '}'
          }

          if (item.data.type == 1 ) {
            if (len == 1) {
              txt = '{c|' + item.name + '}'
            } else {
              txt = '{c|' + item.name.slice(0, 6) + '...}'
            }
          } else if(item.data.type == 2){
            if(item.value > 1) {
              for (var i = 0; i < len; i++) {
                let font = item.name.slice(i * num, i * num + num)
                let t = '{b|' + font + '}'
                if (i == 0) {
                  txt = '{b|' + font + '}'
                } else if ( i == 1) {
                  txt = txt + '\n' + t
                } 
              }
            } else {
              if (len == 1) {
                txt = '{b|' + item.name + '}'
              } else {
                txt = '{b|' + item.name.slice(0, 6) + '...}'
              }
            }
          } else if(item.data.type == 3){
            if(item.value > 1) {
              for (var i = 0; i < len; i++) {
                let font = item.name.slice(i * num, i * num + num)
                let t = '{b|' + font + '}'
                if (i == 0) {
                  txt = t + txt2
                } else if ( i == 1) {
                  txt = txt + '\n' + t
                } 
              }
            } else {
              let t1 = ''
              if (len == 1) {
                t1 = '{b|' + item.name + '}'
              } else {
                t1 = '{b|' + item.name.slice(0, 6) + '...}'
              }
              txt = t1 + txt2
            }
          } else if(item.data.type == 4){
            if (len == 1) {
              txt = '{e|' + item.name + '}'
            } else {
              txt = '{e|' + item.name.slice(0, 5) + '...}'
            }
          } 
          
          if (item.data.type == 1) {
            if (item.name == '医药商业') {
              txt = '{icon1|}' + '\n' + '{d| }' + '\n' + txt
            } else if (item.name == '数字健康') {
              txt = '{icon2|}' + '\n' + '{d| }' + '\n' + txt
            } else if (item.name == '生物医药') {
              txt = '{icon3|}' + '\n' + '{d| }' + '\n' + txt
            } else if (item.name == '器械与耗材') {
              txt = '{icon4|}' + '\n' + '{d| }' + '\n' + txt
            } else {
              txt = '{icon5|}' + '\n' + '{d| }' + '\n' + txt
            }   
          }
          return txt
        },
        rich: {
          a: {
            color: '#fff',
            backgroundColor: '#E96350',
            height: 15,
            width: 16,
            fontSize: 12,
            borderRadius: 9,
            lineHeight: 14,
            padding: [0, 0, 1, 0],
            align: 'center',
          },
          b: {
            color: '#fff',
            width: 90,
            fontSize: 12,
            lineHeight: 16
          },
          c: {
            color: '#fff',
            fontSize: 12,
            lineHeight: 14
          },
          d: {
            height: 2,
            lineHeight: 2
          },
          e: {
            color: '#fff',
            fontSize: 16,
            lineHeight: 16
          },
          icon1: {
            width: 14,
            height: 14,
            align: 'center',
            backgroundColor: {
              image: require('../pic/sabkey-1.png')
            }
          }
          ,
          icon2: {
            width: 14,
            height: 14,
            align: 'center',
            backgroundColor: {
              image: require('../pic/sabkey-2.png')
            }
          }
          ,
          icon3: {
            width: 14,
            height: 14,
            align: 'center',
            backgroundColor: {
              image: require('../pic/sabkey-3.png')
            }
          },
          icon4: {
            width: 14,
            height: 14,
            align: 'center',
            backgroundColor: {
              image: require('../pic/sabkey-4.png')
            }
          },
          icon5: {
            width: 14,
            height: 14,
            align: 'center',
            backgroundColor: {
              image: require('../pic/sabkey-5.png')
            }
          }
        }
      }
    }
  }]
}
export {
  option
}
